import PropTypes from 'prop-types'
import { RdtInfringementTypes } from '../../models/rdt/rdt-infringement-types-enum'
import { iso8601DurationPropType } from '../common/iso-8601-duration-prop-type'
import { iso8601PropType } from '../common/iso-8601-prop-type'
import { rdtInfringementLevelPropType } from './rdt-infringement-level-prop-type'

export const rdtInfringementPropType = PropTypes.shape({
    duration: iso8601DurationPropType,
    endTime: iso8601PropType,
    exceedLimit: iso8601DurationPropType,
    infringementStart: iso8601PropType,
    level: rdtInfringementLevelPropType,
    referenceTime: iso8601PropType,
    startTime: iso8601PropType,
    stringCode: PropTypes.string,
    type: PropTypes.oneOf(Object.values(RdtInfringementTypes))
})
